import { create } from "zustand";
import { Option } from "../data/Option";

type OptionGridStore = {
    selectedOptions: Option[];
    setSelectedOptions: (options: Option[]) => void;
    clearSelectedOptions: () => void;
}

export const useOptionGridStore = create<OptionGridStore>((set) => ({
    selectedOptions: [],
    setSelectedOptions: (options: Option[]) => set(() => ({ selectedOptions: options })),
    clearSelectedOptions: () => set(() => ({ selectedOptions: [] })),
}));